import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenEthnicity as ScreenEthnicityFemale } from '../../../OwnAI/screens/Ethnicity';
import { ScreenEthnicity as ScreenEthnicityMale } from '../../../OwnAIMan/screens/Ethnicity';
import { LayoutDataType } from '../../types';

export const ScreenEthnicity: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenEthnicityMale />;
  }

  return <ScreenEthnicityFemale />;
};
